import { KastAppClientForbiddenType } from '@kalyzee/kast-web-sdk/http';
import { SessionMode } from '../contexts/appStore/hooks';
import { useEffect } from 'react';
import { getGlobalQueryLabel, NavigateGlobalQuery } from './navigate';
import { useAppStoreSelector } from '../contexts/appStore/selectors';
import { useAppContext } from '../contexts/app/context';
import { useSdkContext } from '../contexts/sdk/context';

export const useAuthRedirects = () => {
  const sdkCtx = useSdkContext();
  const mode = useAppStoreSelector(state => state.mode);
  useEffect(() => {
    const httpClient = sdkCtx.client.getHttpClient();

    const forbiddenHandler = (type: KastAppClientForbiddenType) => {
      let reason: string | undefined;
      if (type === KastAppClientForbiddenType.INSUFFICIENT_RIGHTS) reason = 'insufficientrights';
      if (type === KastAppClientForbiddenType.USER_IS_DISABLED) reason = 'udisabled';
      if (type === KastAppClientForbiddenType.USER_IS_BANNED) reason = 'ubanned';
      if (type === KastAppClientForbiddenType.USER_TRIAL_PERIOD_IS_OVER) reason = 'utrialperiodisover';
      if (type === KastAppClientForbiddenType.ORGANIZATION_IS_DISABLED) reason = 'odisabled';
      if (type === KastAppClientForbiddenType.ORGANIZATION_TRIAL_PERIOD_IS_OVER) reason = 'otrialperiodisover';
      if (reason) {
        window.location.href = `/forbidden?r=${reason}${mode === SessionMode.SLAVE ? `&${getGlobalQueryLabel(NavigateGlobalQuery.SLAVE)}=true` : ''}`;
      } else {
        window.location.href = `/login?${mode === SessionMode.SLAVE ? `${getGlobalQueryLabel(NavigateGlobalQuery.SLAVE)}=true` : ''}`;
      }
    }

    const expireHandler = () => {
      const reason = 'sessionexpired';
      window.location.href = `/forbidden?r=${reason}${mode === SessionMode.SLAVE ? `&${getGlobalQueryLabel(NavigateGlobalQuery.SLAVE)}=true` : ''}`;
    };


    httpClient.addEventListener('forbidden', forbiddenHandler);
    httpClient.addEventListener('tokenExpire', expireHandler);

    return () => {
      httpClient.removeEventListener('forbidden', forbiddenHandler);
      httpClient.removeEventListener('tokenExpire', expireHandler);
    };
  }, [])
};